import React, { FC } from "react"
import { CarrotCardModuleBase, CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { FormattedMessage } from "react-intl"
import { DbgPaths } from "utils/Paths"
import { ArrowLink } from "@carrotfertility/carotene"

const CarrotCardEligibleWithDeductibleModule: FC<CarrotCardModuleProps> = () => (
  <CarrotCardModuleBase
    backgroundColor={(theme) => ({ backgroundColor: theme.palette.background.default })}
    body={
      <FormattedMessage defaultMessage="As soon as your deductible is met, you'll be eligible for a Carrot Card, which makes it easy to pay directly from your account." />
    }
    links={[
      <>
        <ArrowLink href={DbgPaths.CARROT_CARD}>
          <FormattedMessage defaultMessage="Learn how Carrot Card works" />
        </ArrowLink>
      </>
    ]}
  />
)

export { CarrotCardEligibleWithDeductibleModule }
